/* eslint-disable react-hooks/exhaustive-deps */
/**
 * LoginButton component.
 * @module components/ItaliaTheme/Header/HeaderSlim/LoginButton
 *
 * Custom:
 * - Target blank - non più presente, da rimettere se il link passa ad un link esterno
 */

import React, { useState, useEffect } from 'react';

import { Button } from 'design-react-kit/dist/design-react-kit';

import config from '@plone/volto/registry';

const LoginButton = ({ children, size = 'full' }) => {
  let [loginURL, setLoginURL] = useState(
    config.settings.siteProperties?.arLoginUrl,
  );

  // useEffect(() => {
  //   if (loginURL && __CLIENT__) {
  //     const current = window?.location?.href ?? '';
  //     if (loginURL.indexOf('came_from') < 0 && current.indexOf('came_from') < 0) {
  //       const came_from = `${loginURL.indexOf('?') >= 0 ? '&' : '?'}${'came_from=' + current}`;
  //       setLoginURL(loginURL + came_from);
  //     }
  //   }
  // }, []);

  return loginURL ? (
    <Button
      className="btn-icon"
      color="primary"
      href={loginURL}
      icon={false}
      size={size}
      tag="a"
      //target="_blank"
    >
      {children}
    </Button>
  ) : (
    <></>
  );
};

export default LoginButton;
